//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Ret",
  data() {
    return {

      form: {
        sHct: "",
        sHct1: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0.095", name: "新生儿（85 mL/kg）", shortName: "985 mL/kg" },
        { value: "0.075", name: "成年男性（75 mL/kg）", shortName: "75 mL/kg" },
        { value: "0.065", name: "成年女性（65 mL/kg）", shortName: "65 mL/kg" },
      ],
      allowable_display: "...",
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        self.allowable_display = "...";
        return "...";
      } else {
        let result = (form.sHct * form.sHct1 / 45).toFixed(0)

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Ret.vue